// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2pzV4","info":"PatientInfo_info__3Pig2"};